import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';

class PackageIndex extends Component {
    render() {
        return (
            <ul className="list-unstyled">
                {this.props.descriptor.files.map((file) => (
                    file.services.map((service) => (
                        <li>
                            <Link to={service.fullName}>service {service.name}</Link>
                        </li>
                    ))
                ))}
                {this.props.descriptor.files.map((file) => (
                    file.messages.map((message) => (
                        <li>
                            <Link to={message.fullName}>message {message.longName}</Link>
                        </li>
                    ))
                ))}
                {this.props.descriptor.files.map((file) => (
                    file.enums.map((en) => (
                        <li>
                            <Link to={en.fullName}>enum {en.name}</Link>
                        </li>
                    ))
                ))}
            </ul>
        );
    }
}

class Index extends Component {
    render() {
        return (
            <article>
                <header>
                    <p className="text-muted">RPC Reference</p>
                    <h1 className="mt-3">Index</h1>
                    <hr />
                </header>
                <ul className="list-unstyled">
                    {this.props.store.packageNames().map((packageName) => (
                        <li className="mt-3">
                            <Link to={packageName}><strong>package {packageName}</strong></Link>
                            <PackageIndex descriptor={this.props.store.descriptor(packageName).package}/>
                        </li>
                    ))}
                </ul>
            </article>
        );
    }

}

export default Index;



// WEBPACK FOOTER //
// ./src/reference/Index.js